import { useState } from 'react'

interface ReadMoreProps {
  id: string
  text: string
  amountOfWords?: number
  /** Section/topic name for the expand control, e.g. "Fund Objective" (Reg_Details_B01) */
  labelContext?: string
}

export const ReadMore = ({ id, text, amountOfWords = 36, labelContext }: ReadMoreProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const splittedText = text.split(' ')
  const itCanOverflow = splittedText.length > amountOfWords
  const beginText = itCanOverflow ? splittedText.slice(0, amountOfWords - 1).join(' ') : text
  const endText = splittedText.slice(amountOfWords - 1).join(' ')

  const expandAccessibleName = labelContext
    ? isExpanded
      ? `Show less about ${labelContext}`
      : `Read more about ${labelContext}`
    : undefined

  return (
    <p id={id}>
      {beginText}{' '}
      {itCanOverflow && (
        <>
          {!isExpanded && <span className='ml-[-4px]'>...</span>}
          <span className={`${!isExpanded && 'hidden'}`} aria-hidden={!isExpanded}>
            {endText}
          </span>
          <button
            type='button'
            className='underline ml-[2px] appearance-none bg-transparent border-0 p-0 font-inherit text-inherit cursor-pointer'
            aria-expanded={isExpanded}
            aria-controls={id}
            aria-label={expandAccessibleName}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? '' : 'read more'}
          </button>
        </>
      )}
    </p>
  )
}
